import { array, string } from 'prop-types';
import React from 'react';
import TooltipBase from './TooltipBase';

const BlankTooltip = ({answer, candidates,...props}) => {
	const elm = candidates.map(((choice, idx)=>(
		<div key={choice+idx}>
            Option { '[' + idx + '] : ' + choice}
		</div>
	)));
	return (
		<TooltipBase {...props}
			render={()=>(
				<React.Fragment>
					<div>Answer : {answer}</div>
					{elm}
				</React.Fragment>
			)}
		/>
	);
};

BlankTooltip.propTypes = {
	answer: string,
	candidates : array,
};

export default BlankTooltip;
